import React, { useState, useRef, useEffect } from "react";
import VisionBot_logo from "../assets/Visionbot.jpg";

const VisionBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({
    x: window.outerWidth - 1350,
    y: 200,
  });

  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const dragging = useRef(false);          // ✅ Enabled
  const offset = useRef({ x: 0, y: 0 });   // ✅ Enabled

  useEffect(() => {
    const handleResize = () => {
      setPosition(pos => ({
        x: Math.min(pos.x, window.innerWidth - 60),
        y: Math.min(pos.y, window.innerHeight - 60),
      }));
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Enabled draggable handlers
  const onMouseDown = e => {
    dragging.current = true;
    offset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
    e.preventDefault();
  };

  const onMouseMove = e => {
    if (!dragging.current) return;
    let newX = e.clientX - offset.current.x;
    let newY = e.clientY - offset.current.y;
    newX = Math.max(0, Math.min(newX, window.innerWidth - 60));
    newY = Math.max(0, Math.min(newY, window.innerHeight - 60));
    setPosition({ x: newX, y: newY });
  };

  const onMouseUp = () => {
    dragging.current = false;
  };

  const toggleCamera = () => {
    if (isOpen && streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    setIsOpen(open => !open);
  };

  useEffect(() => {
    if (isOpen && videoRef.current) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(stream => {
          videoRef.current.srcObject = stream;
          streamRef.current = stream;
        })
        .catch(err => {
          console.error("Error accessing camera: ", err);
        });
    }

    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    };
  }, [isOpen]);

  return (
    <>
      {/* ● Draggable Camera Icon */}
      <div
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
        onClick={() => {
          if (!dragging.current) toggleCamera();
        }}
        style={{
          position: "fixed",
          top: position.y,
          left: position.x,
          width: 60,
          userSelect: "none",
          cursor: "grab",
          zIndex: 1000,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            backgroundColor: "#009688",
            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 8,
            position: "relative",
          }}
        >
          <img
            src={VisionBot_logo}
            alt="Vision Bot"
            style={{
              width: "120%",
              height: "120%",
              borderRadius: "50%",
              pointerEvents: "none",
              userSelect: "none",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: "81%",
              transform: "translateX(-50%)",
              backgroundColor: "#757575e6",
              color: "#000",
              fontSize: 10,
              padding: "2px 6px",
              borderRadius: 12,
              border: "1px solid #000",
              fontWeight: "bold",
              boxShadow: "none",
              whiteSpace: "nowrap",
            }}
          >
            Next release
          </div>
        </div>
        <span
          style={{
            marginTop: 4,
            fontSize: 12,
            fontFamily: "cursive",
            fontWeight: "bold",
            color: "#009688",
            textAlign: "center",
            lineHeight: 1,
          }}
        >
          YOLO&nbsp;Agent
        </span>
      </div>

      {/* ▼ Camera Feed */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: 90,
            right: 20,
            width: 320,
            height: 400,
            borderRadius: 10,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            backgroundColor: "#000",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              backgroundColor: "#009688",
              color: "#fff",
              padding: 10,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            VisionBot
            <button
              onClick={toggleCamera}
              style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              ✕
            </button>
          </div>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            style={{
              flex: 1,
              width: "100%",
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
            }}
          />
        </div>
      )}
    </>
  );
};

export default VisionBot;
